import { render, staticRenderFns } from "./HealthHome.vue?vue&type=template&id=4e1c51b7&"
import script from "./HealthHome.vue?vue&type=script&lang=js&"
export * from "./HealthHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports